export const defaultCell = {
  width: 250,
};

export const tableConfig = {
  tracker_library_version: {
    width: 350,
  },
  user_first_seen: {
    type: 'date',
  },
  session_time: {
    type: 'date',
  },
  pageview_time: {
    type: 'date',
  },
};

// tableConfigNew Objec:
// {
//   name: 'session_time',
//   label: 'Different name to display'
//   type: 'time',
// },

export const tableConfigNew = {
  sessions: [
    {
      name: 'session_id',
    },
    {
      name: 'session_time',
      type: 'time',
      order: true,
    },
    {
      name: 'ip',
    },
    {
      name: 'fingerprint',
      width: 350,
    },
    {
      name: 'landing_page',
      type: 'url',
    },
    {
      name: 'document_size',
    },
    {
      name: 'viewport_size',
    },
    {
      name: 'utm_campaign',
    },
    {
      name: 'utm_content',
    },
    {
      name: 'utm_medium',
    },
    {
      name: 'utm_source',
    },
    {
      name: 'utm_term',
    },
    {
      name: 'google_campaign_id',
    },
    {
      name: 'google_adgroup_id',
    },
    {
      name: 'google_location_id',
    },
    {
      name: 'google_matchtype',
    },
    {
      name: 'google_network',
    },
    {
      name: 'google_device',
    },
    {
      name: 'google_devicemodel',
    },
    {
      name: 'google_creative',
    },
    {
      name: 'google_keyword',
    },
    {
      name: 'google_placement',
    },
    {
      name: 'google_target',
    },
    {
      name: 'google_aceid',
    },
    {
      name: 'google_adposition',
    },
    {
      name: 'yandex_ad_id',
    },
    {
      name: 'yandex_addphrases',
    },
    {
      name: 'yandex_campaign_type',
    },
    {
      name: 'yandex_campaign_id',
    },
    {
      name: 'yandex_creative_id',
    },
    {
      name: 'yandex_device_type',
    },
    {
      name: 'yandex_gbid',
    },
    {
      name: 'yandex_keyword',
    },
    {
      name: 'yandex_phrase_id',
    },
    {
      name: 'yandex_retargeting_id',
    },
    {
      name: 'yandex_coef_goal_con_id',
    },
    {
      name: 'yandex_interest_id',
    },
    {
      name: 'yandex_adtarget_name',
    },
    {
      name: 'yandex_adtarget_id',
    },
    {
      name: 'yandex_position',
    },
    {
      name: 'yandex_position_type',
    },
    {
      name: 'yandex_source',
    },
    {
      name: 'yandex_source_type',
    },
    {
      name: 'yandex_region_name',
    },
    {
      name: 'yandex_region_id',
    },
  ],
  pageviews: [
    {
      name: 'session_id',
    },
    {
      name: 'session_time',
      type: 'time',
    },
    {
      name: 'pageview_id',
    },
    {
      name: 'pageview_time',
      type: 'time',
      order: true,
    },
    {
      name: 'ip',
    },
    {
      name: 'fingerprint',
      width: 350,
    },
    {
      name: 'pageview_event',
    },
    {
      name: 'title',
    },
    {
      name: 'url',
      type: 'url',
      width: 370,
    },
    {
      name: 'referrer_url',
      type: 'url',
      width: 350,
    },
    {
      name: 'document_size',
    },
    {
      name: 'viewport_size',
    },
  ],
  clicks: [
    {
      name: 'session_id',
    },
    {
      name: 'session_time',
      type: 'time',
    },
    {
      name: 'pageview_id',
    },
    {
      name: 'pageview_time',
      type: 'time',
    },
    {
      name: 'click_id',
    },
    {
      name: 'click_time',
      type: 'time',
    },
    {
      name: 'element_name',
    },
    {
      name: 'element_href',
    },
    {
      name: 'element_id',
    },
    {
      name: 'element_class',
    },
    {
      name: 'element_content',
    },
    {
      name: 'target',
    },
  ],

  form_interactions: [
    {
      name: 'session_id',
    },
    {
      name: 'session_time',
      type: 'time',
    },
    {
      name: 'pageview_id',
    },
    {
      name: 'pageview_time',
      type: 'time',
    },
    {
      name: 'event_id',
    },
    {
      name: 'event_time',
      type: 'time',
    },
    {
      name: 'form_id',
    },
    {
      name: 'form_class',
    },
    {
      name: 'form_action',
    },
    {
      name: 'input_name',
    },
    {
      name: 'input_type',
    },
    {
      name: 'input_id',
    },
    {
      name: 'input_class',
    },
    {
      name: 'input_value',
    },
    {
      name: 'input_placeholder',
    },
    {
      name: 'input_autocomplete',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Details/Events/config.js